module.exports = __webpack_public_path__ + "img/logo.4839c1c7.png";